import {ChangeDetectionStrategy, Component, ElementRef, inject, NgZone, OnDestroy, OnInit} from '@angular/core';
import {outletSlot} from './outlet-slot';

@Component({
  selector: 'tanstack-outlet',
  template: '',
  host: {style: 'display: block'},
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TanStackOutletComponent implements OnInit, OnDestroy {
  private readonly element: HTMLElement = inject(ElementRef).nativeElement;
  private readonly ngZone = inject(NgZone);

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => outletSlot.set(this.element));
  }

  ngOnDestroy(): void {
    this.ngZone.runOutsideAngular(() => outletSlot.clear(this.element));
  }
}
